<template>
  <div class="map-container">
    <!-- 可拖拽的抽屉触发器 -->
    <div
      class="drawer-trigger"
      @click="toggleDrawer"
      @mousedown="startDrag"
      :style="{ left: triggerPosition.x + 'px', top: triggerPosition.y + 'px' }"
      ref="dragTrigger"
    >
      <div class="arrow-icon" :class="{ 'arrow-down': isDrawerOpen }">
        <svg
          width="20"
          height="20"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6 9L12 15L18 9"
            stroke="currentColor"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </div>
    </div>

    <!-- 抽屉控制面板 -->
    <div class="drawer-panel" :class="{ 'drawer-open': isDrawerOpen }">
      <div class="drawer-content">
        <!-- 显示控制开关 - 横向排列 -->
        <div class="display-controls">
          <div class="control-group">
            <label class="switch-label">
              <input type="checkbox" v-model="showSchoolLabels" />
              <span class="slider"></span>
              显示名称
            </label>
            <label class="switch-label">
              <input type="checkbox" v-model="isAuto" />
              <span class="slider"></span>
              自动循环
            </label>
          </div>
          <div class="control-group">
            <div class="top-title">{{ title }}</div>
          </div>

          <!-- 合并的学段选择和图例 -->
          <div class="control-group">
            <div class="legend-container">
              <span class="legend-title">显示学段:</span>
              <div class="legend-items">
                <label
                  class="legend-item checkbox-label"
                  v-for="item in periodLegend"
                  :key="item.type"
                >
                  <input type="checkbox" v-model="selectedPeriods[item.type]" :value="item.type" />
                  <span
                    class="legend-checkmark"
                    :style="{
                      backgroundColor: selectedPeriods[item.type]
                        ? item.color
                        : 'rgba(255,255,255,0.1)',
                      borderColor: item.color,
                    }"
                  ></span>
                  <span class="legend-text">{{ item.name }}</span>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 地图容器 -->
    <div ref="chartContainer" class="chart-container"></div>

    <!-- 学校信息面板 -->
    <!-- <div v-if="selectedSchool" class="school-info-panel">
      <div class="panel-header">
        <h3>{{ selectedSchool.name }}</h3>
        <button @click="selectedSchool = null" class="close-btn">×</button>
      </div>
      <div class="panel-content">
        <p>
          <strong>学校编号:</strong>
          {{ selectedSchool.school_no }}
        </p>
        <p>
          <strong>学段:</strong>
          {{ selectedSchool.period }}
        </p>
        <p>
          <strong>县区:</strong>
          {{ selectedSchool.district }}
        </p>
        <p>
          <strong>所在地区:</strong>
          {{ selectedSchool.place }}
        </p>
        <p>
          <strong>学校性质:</strong>
          {{ selectedSchool.category }}
        </p>
        <p>
          <strong>经度:</strong>
          {{ selectedSchool.lng }}
        </p>
        <p>
          <strong>纬度:</strong>
          {{ selectedSchool.lat }}
        </p>
      </div>
    </div> -->
  </div>
</template>

<script setup>
import { ref, onMounted, watch, reactive } from 'vue';
import { useRouter } from 'vue-router';
import * as echarts from 'echarts';

// 导入所有GeoJSON文件
import YuxiJSON from '../../assets/json/玉溪市geo.json';
import YMJSON from '../../assets/json/易门县geo.json';
import CJJSON from '../../assets/json/澄江市geo.json';
import ESJSON from '../../assets/json/峨山彝族自治县geo.json';
import HTJSON from '../../assets/json/红塔区geo.json';
import HNJSON from '../../assets/json/华宁县geo.json';
import JCJSON from '../../assets/json/江川区geo.json';
import THJSON from '../../assets/json/通海县geo.json';
import XPJSON from '../../assets/json/新平彝族傣族自治县geo.json';
import YJJSON from '../../assets/json/元江哈尼族彝族傣族自治县geo.json';

// 导入学校数据 - 使用新的数据格式
import schoolData from '../../assets/json/maps2.json';

const router = useRouter();
const chartContainer = ref(null);
const myChart = ref(null);
const currentMap = ref('yuxi');
const selectedSchool = ref(null);
const dragTrigger = ref(null);
let isAuto = ref(true);
let isAutoTimer = ref(true);

// 抽屉状态
const isDrawerOpen = ref(true);

// 触发器位置 - 默认设置为左上角，距离左边90px
const triggerPosition = reactive({
  x: 300,
  y: 8,
});

// 拖拽状态
const isDragging = ref(false);
const dragStart = reactive({
  x: 0,
  y: 0,
});

// 显示控制
const showSchoolLabels = ref(false);
let selectedPeriods = ref({
  幼儿园: true,
  小学: false,
  初级中学: false,
  高级中学: false,
  中职学校: false, // 新增中职学校
});

// 地图名称映射
const mapConfig = {
  yuxi: { name: '玉溪市', data: YuxiJSON },
  ym: { name: '易门县', data: YMJSON },
  cj: { name: '澄江市', data: CJJSON },
  es: { name: '峨山彝族自治县', data: ESJSON },
  ht: { name: '红塔区', data: HTJSON },
  hn: { name: '华宁县', data: HNJSON },
  jc: { name: '江川区', data: JCJSON },
  th: { name: '通海县', data: THJSON },
  xp: { name: '新平彝族傣族自治县', data: XPJSON },
  yj: { name: '元江哈尼族彝族傣族自治县', data: YJJSON },
};

// 区域名称到地图ID的映射
const areaToMapMap = {
  易门县: 'ym',
  澄江市: 'cj',
  峨山彝族自治县: 'es',
  红塔区: 'ht',
  华宁县: 'hn',
  江川区: 'jc',
  通海县: 'th',
  新平彝族傣族自治县: 'xp',
  元江哈尼族彝族傣族自治县: 'yj',
  玉溪市: 'yuxi',
};

// 学段类型颜色映射 - 增加中职学校颜色
const periodColorMap = {
  幼儿园: '#ff6b6b',
  小学: '#ffaa00',
  初级中学: '#4dabf7',
  高级中学: '#51cf66',
  中职学校: '#cc5de8',
  默认: '#ffd43b',
};

// 图例配置 - 增加中职学校
const periodLegend = ref([
  { type: '幼儿园', name: '幼儿园', color: periodColorMap['幼儿园'] },
  { type: '小学', name: '小学', color: periodColorMap['小学'] },
  { type: '初级中学', name: '初级中学', color: periodColorMap['初级中学'] },
  { type: '高级中学', name: '高级中学', color: periodColorMap['高级中学'] },
  { type: '中职学校', name: '中职学校', color: periodColorMap['中职学校'] },
]);

// 注册所有地图
Object.entries(mapConfig).forEach(([key, config]) => {
  echarts.registerMap(key, config.data);
});

// 切换抽屉状态
const toggleDrawer = () => {
  if (!isDragging.value) {
    isDrawerOpen.value = !isDrawerOpen.value;
  }
};

// 开始拖拽
const startDrag = (e) => {
  isDragging.value = true;
  dragStart.x = e.clientX - triggerPosition.x;
  dragStart.y = e.clientY - triggerPosition.y;

  document.addEventListener('mousemove', onDrag);
  document.addEventListener('mouseup', stopDrag);

  // 阻止默认行为，防止文本选择
  e.preventDefault();
};

// 拖拽中
const onDrag = (e) => {
  if (isDragging.value) {
    triggerPosition.x = e.clientX - dragStart.x;
    triggerPosition.y = e.clientY - dragStart.y;

    // 限制在视口范围内
    const maxX = window.innerWidth - 60; // 减去按钮宽度
    const maxY = window.innerHeight - 60; // 减去按钮高度

    triggerPosition.x = Math.max(10, Math.min(triggerPosition.x, maxX));
    triggerPosition.y = Math.max(10, Math.min(triggerPosition.y, maxY));
  }
};

// 停止拖拽
const stopDrag = () => {
  isDragging.value = false;
  document.removeEventListener('mousemove', onDrag);
  document.removeEventListener('mouseup', stopDrag);
};

// 根据区域编号获取区域名称
const getAreaNameByCode = (areaCode) => {
  const areaMap = {
    530402: '红塔区',
    530403: '江川区',
    530422: '澄江市',
    530424: '华宁县',
    530425: '易门县',
    530426: '峨山彝族自治县',
    530427: '新平彝族傣族自治县',
    // 可以根据需要添加更多区域映射
  };
  return areaMap[areaCode] || '未知区域';
};

// 处理学校数据 - 适配新的数据格式
const processSchoolData = () => {
  // 新的数据格式是 { "RECORDS": [...] }
  const records = schoolData.RECORDS || schoolData;

  if (!Array.isArray(records)) {
    console.error('学校数据格式不正确:', schoolData);
    return [];
  }

  const processedData = records
    .map((school) => {
      const lng = parseFloat(school.lng);
      const lat = parseFloat(school.lat);

      if (isNaN(lng) || isNaN(lat)) {
        console.warn(`学校 ${school.school_name} 的经纬度无效:`, school.lng, school.lat);
        return null;
      }

      return {
        name: school.school_name,
        value: [lng, lat],
        type: school.period,
        school_no: school.school_no,
        period: school.period,
        lng: school.lng,
        lat: school.lat,
        place: school.place,
        category: school.category,
        area_no: school.area_no,
        district: getAreaNameByCode(school.area_no), // 根据区域编号获取区域名称
      };
    })
    .filter((item) => item !== null);

  return processedData;
};

// 根据学校类型获取颜色
const getSchoolColor = (schoolType) => {
  return periodColorMap[schoolType] || periodColorMap['默认'];
};

// 初始化图表
const initChart = () => {
  myChart.value = echarts.init(chartContainer.value);

  // 绑定地图点击事件
  myChart.value.on('click', (params) => {
    if (params.componentType === 'series' && params.componentSubType === 'map') {
      handleMapClick(params.name);
    } else if (params.componentType === 'series' && params.componentSubType === 'scatter') {
      // 点击学校标记点
      handleSchoolClick(params.data);
    }
  });

  updateChart();
};

// 处理地图点击 - 跳转到独立页面
const handleMapClick = (areaName) => {
  const targetMapId = areaToMapMap[areaName];

  if (targetMapId && targetMapId !== currentMap.value) {
    router.push(`/${targetMapId}`);
  }
};

// 处理学校点击
const handleSchoolClick = (schoolData) => {
  selectedSchool.value = schoolData;
};

// 获取过滤后的学校数据
const getFilteredSchools = () => {
  const schoolsData = processSchoolData();
  return schoolsData.filter((school) => selectedPeriods.value[school.type]);
};

let title = ref('玉溪市幼儿园校点分布图');
// 更新图表显示
const updateChart = () => {
  const filteredSchools = getFilteredSchools();

  const option = {
    backgroundColor: 'transparent',
    title: {
      text: title.value,
      left: 'center',
      top: '10px',
      textStyle: {
        color: '#ffffff',
        fontSize: 18,
        fontWeight: 'bold',
        textShadow: '0 0 10px rgba(86, 128, 249, 0.8)',
      },
    },
    tooltip: {
      trigger: 'item',
      backgroundColor: 'rgba(16, 35, 70, 0.9)',
      borderColor: '#5680f9',
      textStyle: {
        color: '#ffffff',
      },
      formatter: function (params) {
        if (params.componentType === 'series') {
          if (params.seriesName === '区县') {
            return `
              <div style="font-weight: bold; margin-bottom: 5px; color: #5680f9;">${params.name}</div>
              <div style="margin-top: 5px; color: #cccccc;">点击查看详情</div>
            `;
          } else if (params.seriesName === '学校') {
            const data = params.data;
            return `
              <div style="font-weight: bold; margin-bottom: 5px; color: #5680f9;">${data.name}</div>
              <div style="color: #cccccc;">类型: ${data.type}</div>
              <div style="color: #cccccc;">所在地区: ${data.place}</div>
              <div style="color: #cccccc;">学校性质: ${data.category}</div>
              <div style="color: #cccccc;">所属区县: ${data.district || '未知'}</div>
              <div style="color: #cccccc;">学校编号: ${data.school_no || '未知'}</div>
            `;
          }
        }
        return params.name;
      },
    },
    geo: {
      map: currentMap.value,
      roam: true,
      zoom: 1,
      center: [102.3, 24.2],
      label: {
        show: true,
        color: 'rgba(255, 255, 255, 0.8)',
        fontSize: 12,
      },
      itemStyle: {
        areaColor: 'rgba(16, 35, 70, 0.8)',
        borderColor: '#5680f9',
        borderWidth: 1.5,
      },
      emphasis: {
        itemStyle: {
          areaColor: 'rgba(86, 128, 249, 0.3)',
        },
        label: {
          color: '#ffffff',
          fontWeight: 'bold',
        },
      },
    },
    series: [
      {
        name: '区县',
        type: 'map',
        map: currentMap.value,
        geoIndex: 0,
        data: generateMapData(currentMap.value),
        itemStyle: {
          areaColor: 'rgba(86, 128, 249, 0.2)',
          borderColor: '#5680f9',
          borderWidth: 1,
        },
        emphasis: {
          itemStyle: {
            areaColor: 'rgba(86, 128, 249, 0.4)',
          },
        },
      },
      {
        name: '学校',
        type: 'scatter',
        coordinateSystem: 'geo',
        data: filteredSchools.map((school) => ({
          name: school.name,
          value: school.value,
          type: school.type,
          school_no: school.school_no,
          period: school.period,
          lng: school.lng,
          lat: school.lat,
          place: school.place,
          category: school.category,
          district: school.district,
          symbolSize: 10,
          itemStyle: {
            color: getSchoolColor(school.type),
            borderColor: '#ffffff',
            borderWidth: 1,
            shadowBlur: 10,
            shadowColor: getSchoolColor(school.type),
          },
        })),
        symbolSize: 10,
        label: {
          show: showSchoolLabels.value,
          formatter: '{b}',
          position: 'right',
          color: '#ffffff',
          fontSize: 10,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          padding: [2, 4],
          borderRadius: 2,
        },
        itemStyle: {
          color: function (params) {
            return getSchoolColor(params.data.type);
          },
          borderColor: '#ffffff',
          borderWidth: 1,
          shadowBlur: 10,
          shadowColor: function (params) {
            return getSchoolColor(params.data.type);
          },
        },
        emphasis: {
          label: {
            show: true,
            color: '#ffffff',
            fontWeight: 'bold',
            backgroundColor: 'rgba(86, 128, 249, 0.8)',
          },
          itemStyle: {
            shadowBlur: 20,
            shadowColor: function (params) {
              return getSchoolColor(params.data.type);
            },
          },
        },
      },
    ],
  };

  myChart.value.setOption(option, true);
};

// 生成地图数据
const generateMapData = (mapId) => {
  const mapData = mapConfig[mapId].data;
  const data = [];

  if (mapData.features) {
    mapData.features.forEach((feature) => {
      if (feature.properties && feature.properties.name) {
        data.push({
          name: feature.properties.name,
          value: Math.floor(Math.random() * 1000) + 1,
        });
      }
    });
  }

  return data;
};

// 窗口大小变化时重绘图表
const handleResize = () => {
  if (myChart.value) {
    myChart.value.resize();
  }
};

// 监听显示控制变化
watch(
  [showSchoolLabels, selectedPeriods],
  () => {
    updateChart();
  },
  { deep: true },
);

watch(
  [isAuto],
  () => {
    clearInterval(isAutoTimer.value);
    isAutoTimer.value = null;
    title = `${mapConfig[currentMap.value].name}学校分布图`;
  },
  { deep: true },
);

const handleSetMark = (mark, val = false) => {
  selectedPeriods.value[mark] = val;
};
let arrList = ['幼儿园', '小学', '初级中学', '高级中学', '中职学校'];
let key = 0;

const setMark = () => {
  handleSetMark(`${arrList[key]}`, false);
  key++;
  if (key === 5) {
    key = 0;
  }
  handleSetMark(`${arrList[key]}`, true);
  title.value = `玉溪市${arrList[key]}校点分布图`;
};

onMounted(() => {
  initChart();
  window.addEventListener('resize', handleResize);
  isAutoTimer.value = window.setInterval(setMark, 5000);

  // 初始化触发器位置为左上角，距离左边180px
  // triggerPosition.x = 180;
  // triggerPosition.y = 10;
});

// 组件卸载前清理
import { onUnmounted } from 'vue';
onUnmounted(() => {
  if (myChart.value) {
    myChart.value.dispose();
  }
  window.removeEventListener('resize', handleResize);
  document.removeEventListener('mousemove', onDrag);
  document.removeEventListener('mouseup', stopDrag);
});
</script>

<style scoped>
.map-container {
  position: relative;
  width: 100%;
  height: 100vh;
  overflow: hidden;
  background: transparent;
}

/* 可拖拽的抽屉触发器 */
.drawer-trigger {
  position: fixed;
  z-index: 1001;
  background: rgba(16, 35, 70, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 20px;
  padding: 8px 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(86, 128, 249, 0.5);
  cursor: pointer;
  transition: all 0.3s ease;
  user-select: none;
  touch-action: none;
}

.drawer-trigger:hover {
  background: rgba(16, 35, 70, 0.95);
  box-shadow: 0 6px 25px rgba(86, 128, 249, 0.4);
  transform: scale(1.05);
  border-color: rgba(86, 128, 249, 0.8);
}

.drawer-trigger:active {
  cursor: grabbing;
}

.arrow-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #5680f9;
  transition: transform 0.3s ease;
}

.arrow-icon.arrow-down {
  transform: rotate(180deg);
}

/* 抽屉面板 */
.drawer-panel {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 1000;
  background: rgba(16, 35, 70, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 0 0 20px 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(86, 128, 249, 0.3);
  border-top: none;
  overflow: hidden;
  transform: translateY(-100%);
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  max-height: 0;
}

.drawer-panel.drawer-open {
  transform: translateY(0);
  max-height: 100px;
}

.drawer-content {
  padding: 15px 20px;
  opacity: 0;
  transition: opacity 0.3s ease 0.1s;
}

.drawer-panel.drawer-open .drawer-content {
  opacity: 1;
}

/* 横向排列的控制项 */
.display-controls {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 30px;
  margin-bottom: 0;
}

.control-group {
  display: flex;
  align-items: center;
  gap: 15px;
}

/* 合并的学段和图例容器 */
.legend-container {
  display: flex;
  align-items: center;
  gap: 15px;
}

.legend-title {
  font-size: 14px;
  color: #ffffff;
  font-weight: 600;
  white-space: nowrap;
}

.legend-items {
  display: flex;
  gap: 15px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  font-size: 12px;
  color: #ffffff;
  position: relative;
  padding-left: 0;
  white-space: nowrap;
}

.legend-item input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
  height: 0;
  width: 0;
}

.legend-checkmark {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid;
  transition: all 0.3s ease;
  flex-shrink: 0;
  position: relative;
}

.legend-checkmark:after {
  content: '';
  position: absolute;
  display: none;
  left: 3px;
  top: 0px;
  width: 4px;
  height: 8px;
  border: solid white;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.legend-item input:checked ~ .legend-checkmark:after {
  display: block;
}

.legend-text {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  white-space: nowrap;
}

.switch-label {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  font-size: 14px;
  color: #ffffff;
  font-weight: 500;
  white-space: nowrap;
}

.switch-label input {
  display: none;
}

.slider {
  position: relative;
  display: inline-block;
  width: 40px;
  height: 20px;
  background-color: rgba(255, 255, 255, 0.2);
  border-radius: 20px;
  transition: 0.4s;
  flex-shrink: 0;
}

.slider:before {
  position: absolute;
  content: '';
  height: 16px;
  width: 16px;
  left: 2px;
  bottom: 2px;
  background-color: white;
  border-radius: 50%;
  transition: 0.4s;
}

input:checked + .slider {
  background-color: #5680f9;
}

input:checked + .slider:before {
  transform: translateX(20px);
}

.chart-container {
  width: 100%;
  height: 100%;
  background: transparent;
}

/* 学校信息面板 */
.school-info-panel {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 1000;
  background: rgba(16, 35, 70, 0.95);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 0;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  border: 1px solid rgba(86, 128, 249, 0.5);
  max-width: 300px;
  min-width: 250px;
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid rgba(86, 128, 249, 0.3);
  background: linear-gradient(135deg, #5680f9, #1e3799);
  border-radius: 12px 12px 0 0;
  color: white;
}

.panel-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

.panel-header .close-btn {
  background: none;
  border: none;
  color: white;
  font-size: 20px;
  cursor: pointer;
  padding: 0;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: background-color 0.3s;
}

.panel-header .close-btn:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.panel-content {
  padding: 20px;
}

.panel-content p {
  margin: 12px 0;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.4;
  display: flex;
  justify-content: space-between;
}

.panel-content strong {
  color: #ffffff;
  font-weight: 600;
  min-width: 80px;
}

/* 响应式设计 */
@media (max-width: 1024px) {
  .display-controls {
    gap: 20px;
  }

  .control-group {
    gap: 10px;
  }

  .legend-items {
    gap: 10px;
  }
}

@media (max-width: 768px) {
  .drawer-trigger {
    padding: 6px 16px;
  }

  .drawer-panel.drawer-open {
    max-height: 120px;
  }

  .drawer-content {
    padding: 40px 15px 15px;
  }

  .display-controls {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }

  .control-group {
    width: 100%;
    justify-content: space-between;
  }

  .legend-container {
    flex-direction: column;
    align-items: flex-start;
    gap: 10px;
  }

  .legend-items {
    flex-wrap: wrap;
    gap: 8px;
  }

  .school-info-panel {
    top: auto;
    bottom: 10px;
    right: 10px;
    left: 10px;
    max-width: none;
  }
}

.top-title {
  color: #fff;
  font-size: 18px;
  font-weight: 'bold';
  text-shadow: '0 0 10px rgba(86, 128, 249, 0.8)';
}
</style>
